import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import LoadingIcon from '../../assets/svg/loader.svg';

const Loader = styled.div`
  align-items: center;
  color: #fff;
  display: flex;
  justify-content: center;
  height: 140px;
`;

const FullPageWrapper = styled.div`
  align-items: center;
  display: flex;
  position: fixed;
  justify-content: center;
  height: 100vh;
  left: 0;
  top: 0;
  width: 100vw;
`;

export default () => (
  <Loader>
    <img src={LoadingIcon} width="40" height="40" alt="Loading" />
  </Loader>
);

export const FullPageLoader = () => (
  <FullPageWrapper>
    <Loader>
      <img src={LoadingIcon} width="40" height="40" alt="Loading" />
    </Loader>
  </FullPageWrapper>
);

const FULL_PAGE_LOADER_DELAY_MS = 300;

// Shows the full-page loader only once loading has taken longer than a blink, so a quick load doesn't flash a spinner.
export const DelayedFullPageLoader = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setIsVisible(true), FULL_PAGE_LOADER_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, []);

  return isVisible ? <FullPageLoader /> : null;
};
